import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close-m",
  "use": "close-m-usage",
  "viewBox": "0 0 23 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 21\" id=\"close-m\"><path d=\"M1 0l21 21m0-21L1 21\" stroke=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol